<template>
  <main class="home">
    <Header
      navbarType="goBack"
      :screenTitle="screenTitle"
      @clicked="goBack()"
    />
    <CreditCancel />
  </main>
</template>
<script lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { defineComponent, ref } from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import CreditCancel from "@/apps/credit-line/components/CreditCancel.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import { safeAndroidCall } from "@/apps/credit-line/helpers/safe-android-call.helper";

export default defineComponent({
  beforeMount() {
    setLanguage(this);
  },
  name: "CreditLineCancelView",
  components: {
    Header,
    CreditCancel,
  },
  setup() {
    const { t } = useI18n();
    let screenTitle = ref(t("CANCELCREDITLINE"));

    const goBack = () => {
      history.back();
    };

    return {
      t,
      screenTitle,
      goBack,
    };
  },
  mounted() {
    safeAndroidCall("finishedLoading");
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.option-btn {
  width: 100%;
  height: 50px;
  background-color: $pj-color-white;
  border-radius: 5px;
  color: $pj-color-green;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
  border-color: $pj-color-green;
  border-width: thin;
}

.active-option {
  width: 100%;
  height: 50px;
  border: none;
  background-color: $pj-color-yellow-green;
  border-radius: 5px;
  color: $pj-color-white;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
}

.cancel-confirm-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 90%;
  height: 50px;
  border: none;
  position: fixed;
  bottom: 35px;
  left: 18px;
}
</style>
